import { defineAction } from '~/prix'
import { z } from 'zod'
import propertyMachineryUpdateAction from './propertyMachineryUpdate.action.json' with { type: 'json' }
import { propertyMachineryObject } from '../propertyMachineryObject'

const propertyMachineryUpdateDefinition = defineAction({
  ...propertyMachineryUpdateAction,
  input: propertyMachineryObject,
  output: z.object({}),
})

export default propertyMachineryUpdateDefinition
